/**
 * Generated by orval 🍺
 * Do not edit manually.
 * CliniShift Manager
 * The CliniShift Manager API is used to manage the CliniShift platform. This API is used by the CliniShift Manager Portal.
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ActivityActorBase = zod.object({
  "type": zod.union([zod.enum(['employee', 'system']),zod.string()]),
  "display_name": zod.string()
});

export type ActivityActorBase = zod.input<typeof ActivityActorBase>;
export type ActivityActorBaseOutput = zod.output<typeof ActivityActorBase>;
